module.exports = __webpack_public_path__ + "3c532d68902a756ae2db5655535651a2.png";